<template>
    <div class="modal_bg" @click="fnEvent(false)" v-if="props.show"
        v-bind:style="{ display: props.show ? 'block' : 'none' }"></div>
    <div class="modal_layer text_modal" id="cert_modal" v-if="props.show"
        v-bind:style="{ display: props.show ? 'block' : 'none' }">
        <p class="modal_txt" v-html="content"></p>
        <div class="modal_btns center" style="gap: 10px;">
            <button v-if="props.yes" class="btn_blue" @click="fnEvent(true)">
                {{ props.yes }}
            </button>
            <button v-if="props.no" class="btn_blue" @click="fnEvent(false)">
                {{ props.no }}
            </button>
        </div>
    </div>
</template>
<script lang="ts">
export default {
    props: {
        content: {
            type: String,
            required: true,
        },
        yes: {
            type: String,
            default: "확인",
        },
        no: {
            type: String,
            default: "취소",
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["close"],
    setup(props: any, { emit }: any) {
        const fnEvent = (result: boolean) => {
            emit("close", result);
        };

        return { props, fnEvent };
    },
};
</script>
